/**
 * 申请交易票
 */
import React from 'react';
import { Input, Button, Row, Col, Icon, Tooltip, Select, DatePicker, Modal} from 'antd';
import { Toast} from 'antd-mobile';
import PageLayout from '../../ui/PageLayout';
import http from '../../../axios/http';
//信息编辑
import ApplicationEdit from './ApplicationEdit';
//信息详情
import ApplicationDetail from './ApplicationDetail';
//申请表打印
import ApplicationPrint from './ApplicationPrint';
//交易票打印
import TicketPrint from './TicketPrint';
//税收缴款书打印
import TaxPrint from './TaxPrint';
//税收缴款书编辑
import TaxEdit from './TaxEdit';
//个人开票确认收款
import PersonCharge from './PersonCharge';
//将数字型字符串做加一操作
import { stringAddOne } from '../../../util/util';
//消息提示
import messager from '../../ui/messager';
//加载中遮罩
import Loading from '../../ui/Loading';
//组织机构加载信息
import OrgSelect from '../../ui/OrgSelect';
//加载参数
import paramUtil from '../../ui/paramUtil';
import { global_data } from '../../ui/auth'

const { confirm } = Modal;


class ApplicationIndex extends React.Component {
    columns = [{
        title: '申请单编号',
        dataIndex: 'applicationId',
        width: '10%',
    }, {
        title: '车架号',
        dataIndex: 'vin',
        width: '10%',
    }, {
        title: '车牌号',
        dataIndex: 'plateNo',
        width: '7%',
        // }, {
        //     title: '新车主',
        //     dataIndex: 'buyerName',
        //     width: '10%',
    }, {
        title: '代办公司',
        dataIndex: 'agencyName',
        width: '12%',
    }, {
        title: '申请时间',
        dataIndex: 'insertTime',
        width: '8%',
        // }, {
        //     title: '环保审核',
        //     dataIndex: 'envState',
        //     width: '10%',
        //     format: { '-1': "未提交", 0: "已保存", 1: "已提交", 2: "审核通过", 3: "审核不通过" }
    }, {
        title: '缴费情况',
        dataIndex: 'payState',
        width: '5%',
        render: (text, record, index) => {
            let title = '未缴费';
            let type = "close";
            if (text === 1) {
                title = '已交费';
                type = "check";
            }
            return (
                <Tooltip title={title}>
                    <Icon type={type} className="table-operate-icon" />
                </Tooltip>
            )
        }
    }, {
        title: '交易票',
        dataIndex: 'invoiceState',
        width: '5%',
        render: (text, record, index) => {
            let title = '未开票';
            let type = "close";
            if (text === 1) {
                title = '已开票';
                type = "check";
            } else if (text === 2) {
                title = '已作废';
                type = 'minus';
            } else if (text === 3) {
                title = '自带交易票';
                type = 'info';
            }
            return (
                <Tooltip title={title}>
                    <Icon type={type} className="table-operate-icon" />
                </Tooltip>
            )
        }
    }, {
        title: '税票',
        dataIndex: 'taxState',
        width: '5%',
        render: (text, record, index) => {
            let title = '未开票';
            let type = "close";
            if (text === 1) {
                title = '已开票';
                type = "check";
            } else if (text === 2) {
                title = '已作废';
                type = 'minus';
            } else if (text === 3) {
                title = '自开税票';
                type = 'info';
            }
            return (
                <Tooltip title={title}>
                    <Icon type={type} className="table-operate-icon" />
                </Tooltip>
            )
        }
    }, {
        title: '税款情况',
        dataIndex: 'sellerPayState',
        width: '5%',
        render: (text, record, index) => {
            let title = '未支付';
            let type = "close";
            if (text === 1) {
                title = record.sellerPayAmount;
                type = null;
            } else if (text === 2) {
                title = '已退款';
                type = 'minus';
            }
            return (
                <Tooltip title={title}>
                    {type == null ? title : <Icon type={type} className="table-operate-icon" />}
                </Tooltip>
            )
        }
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '20%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("TRANSFER_UPDATE")?
                <Tooltip title="修改交易基本信息">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record.applicationId)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("TRANSFER_PRINT_TRANSACTION")?
                <Tooltip title="打印交易票">
                    <Icon type="account-book" theme="filled" className="table-operate-icon" onClick={this.printTicket.bind(this, record.applicationId)} />
                </Tooltip>
                :""}
                {
                    global_data.authCode.includes("TRANSFER_CONFIRM")&&record.agent === 0 && (record.payState === 0 || record.invoiceState === 2) ?
                        <Tooltip title="个人服务费用确认收费">
                            <Icon type="money-collect" theme="filled" className="table-operate-icon" onClick={this.doPersonCharge.bind(this, record)} />
                        </Tooltip>
                        : ''
                }
                {
                    // eslint-disable-next-line eqeqeq
                    global_data.authCode.includes("TRANSFER_PRINT_TAX_BILL")&&record.invoiceState === 1 && record.taxState !== 3 && record.sellerType == 1 ?
                        <Tooltip title="打印税收缴款书">
                            <Icon type="carry-out" theme="filled" className="table-operate-icon" onClick={this.printTaxTicket.bind(this, record.applicationId)} />
                        </Tooltip>
                        : ''
                }
                {
                    global_data.authCode.includes("TRANSFER_UPDATE_TAX_BILL")&&record.invoiceState === 1 && record.taxState !== 3 ?
                        <Tooltip title="修改税收缴款书票据信息">
                            <Icon type="highlight" theme="filled" className="table-operate-icon" onClick={this.updateTax.bind(this, record.applicationId)} />
                        </Tooltip>
                        : ''
                }
                {
                    // eslint-disable-next-line eqeqeq
                    global_data.authCode.includes("TRANSFER_ADD_TAX_BILL")&&record.invoiceState === 1 && record.taxState !== 1 && record.taxState !== 3 && record.sellerType == 1 ?
                        <Tooltip title="自开税收缴款书票据信息">
                            <Icon type="info-circle" theme="filled" className="table-operate-icon" onClick={this.selfTax.bind(this, record.applicationId)} />
                        </Tooltip>
                        : ''
                }
                {
                    global_data.authCode.includes("TRANSFER_DELETE")&&record.payState === 0 && record.invoiceState === 0 ?
                        <Tooltip title="删除">
                            <Icon type="delete" theme="filled" className="table-operate-icon" onClick={this.delete.bind(this, record.applicationId)} />
                        </Tooltip>
                        : ''
                }
                {/* <Tooltip title="详情">
                    <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.detail.bind(this, record.applicationId)} />
                </Tooltip> */}
                {global_data.authCode.includes("TRANSFER_PRINT_APPLY")?
                <Tooltip title="打印申请表">
                    <Icon type="printer" theme="filled" className="table-operate-icon" onClick={this.printApplication.bind(this, record.applicationId)} />
                </Tooltip>
                :""}
                {/* 现在已经不需要再提交环保局了，关闭按钮 */}
                {/* <Tooltip title="提交环保局">
                    <Icon type="environment" theme="filled" className="table-operate-icon" onClick={this.submitEnv.bind(this, record.applicationId)} />
                </Tooltip> */}

                {global_data.authCode.includes("TRANSFER_INVOICE")?
                <Tooltip title="开具数电发票">
                    <Icon type="highlight" theme="filled" className="table-operate-icon" onClick={this.invoice.bind(this, record.applicationId, 'Y')} />
                </Tooltip>
                :""}

                {global_data.authCode.includes("TRANSFER_INVOICE")?
                    <Tooltip title="开具数电电子发票">
                        <Icon type="tag"  theme="filled" style={{ color: '#409EFF' }} className="table-operate-icon" onClick={this.invoice.bind(this, record.applicationId, 'N')} />
                    </Tooltip>
                    :""}

                {global_data.authCode.includes("TRANSFER_INVOICE") && record.electricInvoice === '1'?
                    <Tooltip title="下载数电发票">
                        <Icon type="file-pdf"  theme="filled" style={{ color: '#F5222D' }} className="table-operate-icon" onClick={this.invoicePdfFile.bind(this, record.applicationId)} />
                    </Tooltip>
                    :""}

            </div>
        ),
    }];

    state = {
        visible: false,
        printVisible: false,
        ticketVisible: false,
        loadData: '',
        editData: {},   //编辑页面使用的数据
        printData: {},  //打印申请单页面使用的数据
        ticketData: {}, //打印交易票页面使用的数据
        detailData: {},  //详情页面使用的数据
        taxPrintData: {}, //税收缴款书页面使用的数据
        taxPrintVisible: false, //税收缴款书的打印
        taxEditVisible: false, //税收缴款书的编辑
        taxEditData: {}, //税收缴款书页面使用的数据

        //个人服务收费
        personChargeVisible: false, // 个人开票的收费窗口
        personChargeData: {}, // 个人开票时的收费数据
        queryData: {}, //查询数据

        loadingVisible: false,

        taxFiller: '',
        taxAuthorities: '',
    };

    componentDidMount() {
        paramUtil.memberParam(
            { code: 'tax_filler' },
            (res) => {
                this.setState({ taxFiller: res });
            }
        );
        paramUtil.memberParam(
            { code: 'tax_authorities' },
            (res) => {
                this.setState({ taxAuthorities: res });
            }
        );
    }


    add = () => {
        delete this.state.editData.image;
        let editData = {
            agent: 1, //新增时，默认是代办
            destination: '福建省厦门市',
            "buyer.creditType": 'P1',
            "seller.creditType": 'P1',
        };
        this.setState({
            editData: editData,
            visible: true
        });
        this.initEdit(editData);
    }

    update = (info, e) => {
        this.setState({ loadingVisible: true });
        http.post({
            url: '/application/findApplicationInfo',
            data: { applicationId: info },
            success: (res) => {
                this.transferData(res, "buyer");
                this.transferData(res, "seller");
                this.transferData(res, "vehicle");
                //this.transferData(res, "ticket");
                this.setState({ editData: res, visible: true, loadingVisible: false });
                this.initEdit(res);

            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }
    transferData = (res, field) => {
        let buyer = res[field];
        for (let key in buyer) {
            res[field + "." + key] = buyer[key];
        }
        delete res[field];
    }
    delete = (info, e) => {
        messager.confirm("是否删除该申请单？", () => {
            http.post({
                url: '/application/deleteApplication',
                data: { applicationId: info },
                success: (res) => {
                    this.state.loadData();
                    messager.notify("删除成功！");
                }
            });
        });
    }
    detail = (info, e) => {
        http.post({
            url: '/application/findApplicationDetail',
            data: { applicationId: info },
            success: (res) => {
                this.transferData(res, "buyer");
                this.transferData(res, "seller");
                this.transferData(res, "vehicle");
                //this.transferData(res, "ticket");
                res["vehicle.isImported"] = res["vehicle.isImported"] === 1 ? '是' : '否';
                res["agent"] = res["agent"] === 1 ? '是' : '否';
                this.setState({ detailData: res });
                this.showModalDetal();
            }
        });
    }

    hiddenModal = () => {
        this.setState({ visible: false, editData: {} });
    }
    showModalDetal = () => {
        this.setState({ detailVisible: true });
    }
    hiddenModalDetail = () => {
        this.setState({ detailVisible: false });
    }

    printApplication = (info, e) => {
        http.post({
            url: '/application/findPrintApplicationInfo',
            data: { applicationId: info },
            success: (res) => {
                this.setState({ printData: res, printVisible: true });
            }
        });
    }
    hiddenModalPrint = () => {
        this.setState({ printVisible: false });
    }
    printTicket = (info, e) => {
        this.setState({ loadingVisible: true });
        http.post({
            url: '/application/findTicketInfo',
            data: { applicationId: info },
            success: (res) => {
                this.transferData(res, "buyer");
                this.transferData(res, "seller");
                this.transferData(res, "vehicle");
                this.transferData(res, "imageUrl");
                //this.transferData(res, "ticket");
                this.setState({ ticketData: res, loadingVisible: false, ticketVisible: true });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    hiddenModalTicket = () => {
        this.setState({ ticketVisible: false });
    }

    //税收缴款书
    printTaxTicket = (id, e) => {
        http.post({
            url: '/taxTicket/findTaxTicketInfo',
            data: { applicationId: id },
            success: (info) => {
                if (info.filler === undefined || info.filler == null || info.filler === "") {
                    info.filler = this.state.taxFiller;
                }
                if (info.taxAuthorities === undefined || info.taxAuthorities == null || info.taxAuthorities === "") {
                    // info.taxAuthorities = "湖里国税";
                    info.taxAuthorities = this.state.taxAuthorities;
                }
                info.buyerType = info.buyerType + "";
                info.sellerType = info.sellerType + "";
                info.sellerTaxNoTemp = info.sellerTaxNo;
                info.buyerTaxNoTemp = info.buyerTaxNo;
                if (info.sellerTaxNo == null || info.sellerTaxNo === "" || info.buyerTaxNo == null || info.buyerTaxNo === "") {
                    http.post({
                        url: '/taxTicket/getMaxTaxNo',
                        success: (res) => {
                            if (info.sellerTaxNo == null || info.sellerTaxNo === "") {
                                let sellerTaxNo = stringAddOne(res);
                                res = sellerTaxNo;
                                info.sellerTaxNoTemp = sellerTaxNo;
                            }
                            if (info.buyerTaxNo == null || info.buyerTaxNo === "") {
                                info.buyerTaxNoTemp = stringAddOne(res);
                            }
                            this.taxPrintRef.initPrintData(info);
                            this.showModalTax();
                        }
                    });
                } else {
                    this.taxPrintRef.initPrintData(info);
                    this.showModalTax();
                }
            }
        });
    }
    showModalTax = () => {
        this.setState({ taxPrintVisible: true });
    }
    hiddenModalTax = () => {
        this.setState({ taxPrintVisible: false });
    }
    onTaxPrintRef = (ref) => {
        this.taxPrintRef = ref;
    }
    onTaxEditRef = (ref) => {
        this.taxEditRef = ref;
    }

    //修改税收缴款书
    updateTax = (id, e) => {
        http.post({
            url: '/taxTicket/findTaxTicketInfo',
            data: { applicationId: id },
            success: (info) => {
                if (info.filler === undefined || info.filler == null || info.filler === "") {
                    info.filler = this.state.taxFiller;
                }
                if (info.taxAuthorities === undefined || info.taxAuthorities == null || info.taxAuthorities === "") {
                    //info.taxAuthorities = "湖里国税";
                    info.taxAuthorities = this.state.taxAuthorities;
                }
                info.buyerType = info.buyerType + "";
                info.sellerType = info.sellerType + "";
                this.setState({ taxEditData: info });
                this.showModalTaxEdit();
                this.taxEditRef.initCalculation(info);
            }
        });
    }
    showModalTaxEdit = () => {
        this.setState({ taxEditVisible: true });
    }
    hiddenModalTaxEdit = () => {
        this.setState({ taxEditVisible: false });
    }

    //自开税收缴款书
    selfTax = (id, e) => {
        messager.confirm("此操作将导致无法对此单据开税票，是否确定将此单据设置为自开税票？", () => {
            http.post({
                url: '/application/updateTaxToSelf',
                data: { applicationId: id },
                success: (res) => {
                    this.state.loadData();
                    messager.notify("修改成功！");
                }
            });
        });
    }

    //个人服务收费
    doPersonCharge = (info, e) => {
        http.post({
            //因为只需要一个卖方和卖方的信息，所以这里直接用税收缴款书的接口
            url: '/application/findPrintApplicationInfo',
            data: { applicationId: info.applicationId },
            success: (res) => {
                let personChargeData = {
                    applicationId: info.applicationId,
                    amount: info.commission, //服务费用
                    buyerName: res.buyerName,
                    buyerCreditNo: res.buyerCreditNo,
                    sellerName: res.sellerName,
                    sellerCreditNo: res.sellerCreditNo,
                };
                this.setState({ personChargeData: personChargeData, personChargeVisible: true })
            }
        });
    }
    hiddenModalPersonCharge = () => {
        this.setState({ personChargeVisible: false });
    }


    //提交环保局
    submitEnv = (info, e) => {
        messager.confirm("是否提交该数据到环保局？", () => {
            http.post({
                url: '/application/submitEnv',
                data: { applicationId: info },
                success: (res) => {
                    messager.notify("提交数据到环保局成功！");
                    this.state.loadData();
                }
            });
        });
    }

    reloadDataFunc = () => {
        this.state.loadData();
        if (this.state.ticketVisible) {
            this.printTicket(this.state.ticketData.applicationId);
        } else if (this.state.printVisible) {
            this.printApplication(this.state.printData.applicationId);
        }
    }

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.queryString = value
        this.state.loadData(queryData);
        this.setState({ queryData: queryData });
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    selectChange = (value) => {
        let queryData = this.state.queryData;
        queryData.invoiceState = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    //所属市场查询
    orgSelect = (value) => {
        let queryData = this.state.queryData;
        queryData["orgCode"] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    // 导出
  download = () => {
    let queryData = this.state.queryData;
    if (queryData.startDate == null || queryData.endDate === "") {
        messager.notify("导出时需选择时间段！", null, "warning");
        return;
    }
    this.setState({ loadingVisible: true });
    let fileName = queryData.startDate + "~" + queryData.endDate + "-transfer.xlsx";
    http.download({
      url: '/application/excel',
      data: queryData,
      fileName: fileName,
      success: (res) => {
        this.setState({ loadingVisible: false });
      }
  });
  messager.notify("只会根据查询的时间段导出已经打印的数据！");
  }
    //开具
    invoice = (applicationId, paperFlag, e) => {
        let msg = "是否开具数电发票？";
        if (paperFlag === 'N') {
            msg = "是否开具数电电子发票？";
        }

        messager.confirm(msg, () => {
            this.setState({ loadingVisible: true });
            http.post({
                url: '/application/getElectricInvoice',
                data: { applicationId: applicationId, paperInvoiceFlag: paperFlag },
                success: (res) => {
                    // debugger
                    if(res.code==="0"||res.code===200){
                        if (paperFlag === 'Y') {
                            Toast.success('发送成功！');
                        }
                        if (paperFlag === 'N') {
                            confirm({
                                title: '请选择您的操作',
                                content: '开具发票成功，是否下载电子发票？',
                                cancelText: '否',
                                okText: '是',
                                onOk:()=> {
                                    this.invoicePdfFile(applicationId)
                                },
                                onCancel() {},
                            });
                            this.reloadDataFunc()
                        }

                    }else{
                        messager.alert(res.message, "异常", "error");
                    }
                    this.setState({loadingVisible: false });
                },
                error: (res) => {
                    messager.alert(res, "异常", "error");
                    this.setState({ loadingVisible: false });
                }
            });
        });
    }
    invoicePdfFile = (applicationId, e) => {
        this.setState({ loadingVisible: true });
        http.post({
            url: '/application/getElectricInvoiceUrl',
            data: { applicationId: applicationId },
            success: (res) => {

                if(res.code==="0"||res.code===200){
                    if (res.url) {
                        let url = res.url;
                        url = url.replace(/^http:\/\//, 'https://');
                        // window.open(res.url, "_blank");
                        const link = document.createElement('a');
                        link.href = url;
                        link.download = ''; // 可选，若设置会强制下载而不是打开
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                }else{
                    messager.alert(res.message, "异常", "error");
                }
                this.setState({loadingVisible: false });
            },
            error: (res) => {
                messager.alert(res, "异常", "error");
                this.setState({ loadingVisible: false });
            }
        });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Input.Search
                                    placeholder="车牌号/车架号"
                                    onSearch={this.inputSearch}
                                    enterButton
                                    style={{ width: '250px' }}
                                />
                                <Select defaultValue="" style={{ width: 120, marginLeft: '10px', marginRight: '10px' }} onChange={this.selectChange}>
                                    <Select.Option value="">全部</Select.Option>
                                    <Select.Option value="0">未开票</Select.Option>
                                    <Select.Option value="1">已开票</Select.Option>
                                    <Select.Option value="2">已作废</Select.Option>
                                </Select>
                                <DatePicker.RangePicker onChange={this.rangePickerChange} style={{ marginRight: '10px' }} />

                                <OrgSelect style={{ width: '200px' }}
                                    onChange={this.orgSelect}
                                    allowClear={true}
                                    orgType={4}
                                    treeDefaultExpandAll={true} />
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                                {global_data.authCode.includes("TRANSFER_ADD")?
                                <Button type="primary" onClick={this.add}>新增</Button>
                                :""}
                                {global_data.authCode.includes("TRANSFER_EXPORT")?
                                <Button type="primary" onClick={this.download.bind(this)} style={{ marginLeft: '20px' }} >导出</Button>
                                :""}
                            </Col>
                        </Row>
                    )}
                    rowKey="applicationId"
                    url="/application/findApplicationPage"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                {/* <QRCode
                    value='http://www.baidu.com'  //value参数为生成二维码的链接
                    size={200} //二维码的宽高尺寸
                    fgColor="#000000"  //二维码的颜色
                /> */}
                <ApplicationEdit
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.reloadDataFunc}
                    initFunc={(func) => { this.initEdit = func }}
                />
                <ApplicationDetail
                    visible={this.state.detailVisible}
                    onCancel={this.hiddenModalDetail.bind(this)}
                    detailData={this.state.detailData}
                />
                <ApplicationPrint
                    visible={this.state.printVisible}
                    onCancel={this.hiddenModalPrint.bind(this)}
                    printData={this.state.printData}
                    editFunc={this.update.bind(this)}
                />
                <TicketPrint
                    visible={this.state.ticketVisible}
                    onCancel={this.hiddenModalTicket.bind(this)}
                    ticketData={this.state.ticketData}
                    editFunc={this.update.bind(this)}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
                <TaxPrint
                    visible={this.state.taxPrintVisible}
                    onCancel={this.hiddenModalTax.bind(this)}
                    onRef={this.onTaxPrintRef}

                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
                <TaxEdit
                    visible={this.state.taxEditVisible}
                    onCancel={this.hiddenModalTaxEdit.bind(this)}
                    editData={this.state.taxEditData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    onRef={this.onTaxEditRef}
                />
                <PersonCharge
                    visible={this.state.personChargeVisible}
                    onCancel={this.hiddenModalPersonCharge.bind(this)}
                    editData={this.state.personChargeData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
                <Loading
                    visible={this.state.loadingVisible}
                    message="数据加载中"
                />
            </div>
        )
    }

}

export default ApplicationIndex;
